export class AuthorizedValueConverter {
	toView(routes: Array<string>, select: Array<string>) {
		if (select && select.length > 0) {
			return routes.filter((route: any) => {

				if (route.config.roles) {
					return route.config.roles.some((role: string) => {
						return select.indexOf(role) > -1;
					});
				} else
					return [];
			});
		}
		else
			return [];
	}
﻿}